import { render, staticRenderFns } from "./ICN003-03_info_point.vue?vue&type=template&id=0ce2d71a&"
import script from "./ICN003-03_info_point.vue?vue&type=script&lang=js&"
export * from "./ICN003-03_info_point.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports